<template>
  <BlueprintsContainer />
</template>

<script lang="ts">
import Vue from "vue";
import BlueprintsContainer from "@/components/projects/project/house/blueprints/container/BlueprintsContainer.vue";

export default Vue.extend({
  components: {
    BlueprintsContainer,
  },
});
</script>
